import Vuex from 'vuex';
import Vue from 'vue';
import {calculationModule} from '../components/calculation/store';
import {locatorModule} from '../components/locator/store';
import {downloadModule} from '../components/download/store';
import {ssvOrderModule} from '../components/ssv-order/store';
import {reconstructionChallengeModule} from '../components/reconstruction-challenge/store';
import {trophyChallengeModule} from '../components/trophy-challenge/store';
import {contactModule} from '../components/contact/store';
import {errorModule} from '../components/error/store';
import {cadModule} from "../components/cad/store";

Vue.use(Vuex);

export default new Vuex.Store({
    strict: false, // process.env.NODE_ENV !== 'production',
    modules: {
        calculation: calculationModule,
        locator: locatorModule,
        download: downloadModule,
        cad: cadModule,
        ssvOrder: ssvOrderModule,
        reconstructionChallenge: reconstructionChallengeModule,
        trophyChallenge: trophyChallengeModule,
        contact: contactModule,
        error: errorModule
    },
})



// WEBPACK FOOTER //
// ./src/store/index.js